import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

type UsersAuthResponse = {
  token: string;
  user: {
    id: number;
    email: string;
  };
};

type UsersMeResponse = {
  user: {
    id: number;
    email: string;
  };
};

type UsersDeleteResponse = {
  status: string;
  messages?: string[];
  user?: Record<string, never>;
};

@Injectable({
  providedIn: 'root',
})
export class UsersApiService {
  private readonly apiBase = environment.apiBase || 'http://localhost:13000';
  private readonly jsonHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(private readonly http: HttpClient) {}

  login(email: string, password: string): Observable<UsersAuthResponse> {
    return this.http.post<UsersAuthResponse>(
      `${this.apiBase}/api/users/login`,
      { email, password },
      { headers: this.jsonHeaders }
    );
  }

  signup(email: string, password: string, passwordConfirmation: string): Observable<UsersAuthResponse> {
    return this.http.post<UsersAuthResponse>(
      `${this.apiBase}/api/users/signup`,
      {
        user: {
          email,
          password,
          password_confirmation: passwordConfirmation,
        },
      },
      { headers: this.jsonHeaders }
    );
  }

  me(token: string): Observable<UsersMeResponse> {
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    return this.http.get<UsersMeResponse>(`${this.apiBase}/api/users/me`, { headers });
  }

  deleteMe(token: string): Observable<UsersDeleteResponse> {
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    return this.http.delete<UsersDeleteResponse>(`${this.apiBase}/api/users/me.json`, { headers });
  }
}
